function readCookie(name) {
    if (typeof document === 'undefined')
        return null;
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}
function writeCookie(name, value) {
    if (typeof document === 'undefined')
        return;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}
export function getOrCreateSessionId() {
    let id = readCookie('webchatSessionId');
    if (id)
        return id;
    const generated = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `sess_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    writeCookie('webchatSessionId', generated);
    return generated;
}
export function extractSubFromJwt(token) {
    if (!token)
        return undefined;
    const parts = token.split('.');
    if (parts.length < 2)
        return undefined;
    try {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        const sub = payload && typeof payload.sub === 'string' ? payload.sub : undefined;
        return sub;
    }
    catch (_a) {
        return undefined;
    }
}
